import React from 'react';
import { useTheme } from '@emotion/react';

import * as DietaryIcons from './dietaryIcons/index';

type Props = {
  className?: string,
  iconName: string,
  mode: 'light' | 'dark',
  name: string,
};

export const DietaryIconsList = {
  'Cereals containing gluten': DietaryIcons.Gluten,
  'Dairy Free': DietaryIcons.DairyFree,
  'Gluten Free': DietaryIcons.GlutenFree,
  'May Contain Celery': DietaryIcons.Celery,
  'May Contain Crustaceans': DietaryIcons.Crustaceans,
  'May Contain Eggs': DietaryIcons.Eggs,
  'May Contain Fish': DietaryIcons.Fish,
  'May Contain Gluten': DietaryIcons.Gluten,
  'May Contain Lupin': DietaryIcons.Lupin,
  'May Contain Milk': DietaryIcons.Dairy,
  'May Contain Molluscs': DietaryIcons.Mollusks,
  'May Contain Mustard': DietaryIcons.Mustard,
  'May Contain Nuts': DietaryIcons.Nuts,
  'May Contain Peanuts': DietaryIcons.Peanuts,
  'May Contain Sesame': DietaryIcons.Sesame,
  'May Contain Soya': DietaryIcons.Soya,
  'May Contain Sulphites': DietaryIcons.Sulphites,
  'Nuts: Hazelnuts': DietaryIcons.Nuts,
  'Wheat Free': DietaryIcons.WheatFree,
  Celery: DietaryIcons.Celery,
  Crustaceans: DietaryIcons.Crustaceans,
  Eggs: DietaryIcons.Eggs,
  Fish: DietaryIcons.Fish,
  Garlic: DietaryIcons.Garlic,
  Gluten: DietaryIcons.Gluten,
  Lupin: DietaryIcons.Lupin,
  Milk: DietaryIcons.Dairy,
  Molluscs: DietaryIcons.Mollusks,
  Mustard: DietaryIcons.Mustard,
  Nuts: DietaryIcons.Nuts,
  Paleo: DietaryIcons.Paleo,
  Peanuts: DietaryIcons.Peanuts,
  Pescatarian: DietaryIcons.Pescatarian,
  Sesame: DietaryIcons.Sesame,
  Soya: DietaryIcons.Soya,
  Sulphites: DietaryIcons.Sulphites,
  Vegan: DietaryIcons.Vegan,
  Vegetarian: DietaryIcons.Vegetarian,
};

export const RestrictionIcon = ({ className, iconName, mode = 'light', name }: Props) => {
  const theme = useTheme();
  const Component = DietaryIconsList[iconName];
  const fill = mode === 'dark' ? theme.color.white : theme.color.black;

  return Component ? (
    <Component className={className} dataTest={name} fill={fill} iconName={iconName} mode={mode} name={name} />
  ) : null;
};
